import React, {Component} from 'react';
import PropTypes from 'prop-types';
import  {connect} from 'react-redux';
import FormInput from './FormInput';
import {getTranslate, getActiveLanguage} from "react-localize-redux";

import SwitchButton from './SwitchButton';

class MixForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            switchButton: this.props.checked,
        };
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
    }

    handleSwitchChange(event) {
        this.setState({
            switchButton: !this.state.switchButton,
        })
    }

    render() {
        const options = [{

        }];

        const labelStyle ={
            padding: '10px',
        };

        return (
            <div className='row'>
                {this.props.switchButton.position === 'top'
                    ? <SwitchButton
                        articleID={this.props.articleID}
                        divClass={this.props.switchBtnClass}
                        switchButton = {this.state.switchButton}
                        name={this.props.switchName}
                        value={this.props.switchValue}
                        checked={this.props.switchChecked}
                        labelName = {this.props.switchButton.labelName}
                        labelPosition = {this.props.switchButton.labelPosition}
                        onSwitchChange = {this.handleSwitchChange}
                    /> : null
                }
                <div className={this.props.divClass}>
                    <div className='row' style={{marginBottom: '0'}}>
                        <FormInput
                            type='radio'
                            divClass={this.props.divClass === 'col xl8' || this.props.divClass === 'col s9 offset-s3'  ? 'col m3 xl2 ' : 'col s3'}
                            value={this.props.radioValue1}
                            name={this.props.radioName}
                            id={this.props.radioId1}
                            disabled={this.props.radioDisabled1 || this.props.checkboxDisabled}
                            checked={this.props.radioChecked1}/>
                        <FormInput
                            type='number'
                            value={this.props.inputValue1}
                            name={this.props.inputName1}
                            id={this.props.inputId1}
                            min={this.props.inputMin1}
                            max={this.props.inputMax1}
                            step={this.props.inputStep1}
                            disabled={!this.props.radioDisabled1 && !this.props.checkboxDisabled ? false : true}
                            divClass={this.props.divClass === 'col xl8' || this.props.divClass === 'col s9 offset-s3'  ? 'col m9 xl10' : 'col s9'}
                            fieldStyle={{width: '100%', padding: '0'}} />
                    </div>
                </div>
                <FormInput
                    type='checkbox'
                    labelPosition='inline'
                    labelStyle={labelStyle}
                    labelName={this.props.checkboxLabelName || this.props.translate('BATHTUB.stepTwo.form.checkbox')}
                    divClass={this.props.radioCheckboxClass}
                    name={this.props.checkboxName}
                    id={this.props.checkboxId}
                    value={this.props.checkboxValue}
                    disabled={this.props.checkboxDisabled}
                    checked={this.props.checkboxChecked}/>
                <div className={this.props.divClass}>
                    <div className='row' style={{marginBottom: '0'}}>
                        <FormInput
                            type='radio'
                            labelStyle={labelStyle}
                            divClass={this.props.divClass === 'col xl8' || this.props.divClass === 'col s9 offset-s3'  ? 'col m3 xl2' : 'col s3'}
                            value={this.props.radioValue2}
                            name={this.props.radioName}
                            id={this.props.radioId2}
                            disabled={this.props.radioDisabled2 || this.props.checkboxDisabled}
                            checked={this.props.radioChecked2}/>
                        <FormInput
                            type='number'
                            value={this.props.inputValue2}
                            name={this.props.inputName2}
                            id={this.props.inputId2}
                            min={this.props.inputMin2}
                            max={this.props.inputMax2}
                            step={this.props.inputStep2}
                            disabled={!this.props.radioDisabled2 && !this.props.checkboxDisabled ? false : true}
                            divClass={this.props.divClass === 'col xl8' || this.props.divClass === 'col s9 offset-s3' ? 'col m9 xl10' : 'col s9'}
                            fieldStyle={{width: '100%', padding: '0'}}/>
                    </div>
                </div>
                {this.props.switchButton.position === 'bottom'
                    ? <SwitchButton
                        articleID={this.props.articleID}
                        divClass={this.props.switchBtnClass}
                        switchButton = {this.state.switchButton}
                        name={this.props.switchName}
                        value={this.props.switchValue}
                        checked={this.props.switchChecked}
                        labelName = {this.props.switchButton.labelName}
                        labelPosition = {this.props.switchButton.labelPosition}
                        onSwitchChange = {this.handleSwitchChange}/>
                    : null
                }
            </div>
        );
    };

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
MixForm.propTypes = {
    switchButton:          PropTypes.object,
    position:              PropTypes.string,
    maxLength:             PropTypes.number,
    checked:               PropTypes.bool,
    options:               PropTypes.array,
    type:                  PropTypes.string,
    divClass:              PropTypes.string,
    radioCheckboxClass:    PropTypes.string,
    radioCheckboxPosition: PropTypes.string,
    switchBtnClass:        PropTypes.string,
    radioName:             PropTypes.string,
    currentChecked:        PropTypes.string,
    checkboxId:            PropTypes.string,
    inputMax1:             PropTypes.number,
    inputMax2:             PropTypes.number,
};


function mapStateToProps({locale}) {
    return {
        translate: getTranslate(locale),
    }
}

export default connect(mapStateToProps)(MixForm);



// WEBPACK FOOTER //
// ./src/components/forms/MixForm.js